<template>
    <v-layout row wrap>
        <v-flex class="card_box" xs6 sm3 md2 lg2 @click="modeNewAugmentation">
            <div id="add_augmentation">
                <div id="add_augmentation_content">
                    <i class="fas fa-plus" />
                    <p>Nouvelle augmentation</p>
                </div>
            </div>
        </v-flex>
        <augmentations-cards v-for="(augmentation,index) in augmentationsFilter" :key="index"
                             :augmentation="augmentation" />
    </v-layout>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'AugmentationsGrid',
        components: {
            AugmentationsCards: () => import('./AugmentationsCard')
        },
        props: {
            sort: {
                type: Function
            },
            search: {
                type: String,
                default: null
            },
            order: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters('augmentations', ['augmentations']),
            augmentationsFilter: function () {
                var res = [...this.augmentations];
                res = this.search !== null ? res.filter(item => {
                    return item.name.toLowerCase().includes(this.search.toLowerCase());
                }) : res;
                res = this.sort ? res.sort(this.sort) : res;
                res = this.order ? res.reverse() : res;
                return res;
            }
        },
        methods: {
            ...mapActions('augmentations', ['modeNewAugmentation'])
        }
    };
</script>

<style lang="scss" scoped>

    #add_augmentation {
        background-color: #FFF;
        transition: 0.3s ease;
        cursor: pointer;
        border-radius: 5px;
        height: 100%;
        min-height: 130px;
        overflow: hidden;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);

        i {
            font-size: 50px;
            transition: 0.3s ease;
            color: #169CEB !important;
        }

        p {
            font-size: 15px;
            color: #4A4A4A !important;
        }

        &:hover {
            border: 3px solid #169CEB;

            i {
                transform: rotate(180deg);
                transition: 0.3s ease;
            }
        }
    }

    #add_augmentation_content {
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .card_box {
        padding: 10px !important;
        height: 150px;
    }
</style>
